export const doubleEncode = (string) => encodeURIComponent(encodeURIComponent(string));



// WEBPACK FOOTER //
// ./src/js/utils/double-encode.js